import { Injectable } from '@angular/core';
import { GetQuoteDetailsService } from '@core/services/get-quote-details.service';
import { GoogleAnalyticsEventsService } from '@core/services/google-analytics-events.service';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

@Injectable()
export class SharedDataService {
  public data: any;

  public constructor(
    private GoogleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private cookieService: CookieService,
    private GetQuoteDetailsService: GetQuoteDetailsService,
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService
  ) {
    /** Create initial Shared Object */
    this.data = {};
    this.data.pointOfLease = {
      flow: '',
      quoteID: 0,
      polRateDetails: [],
      type: '',
    };
    this.data.userActions = {};
    this.data.settingsData = {};
    this.data.sessionResidentInfo = {};
    this.data.sessionPrimaryResidentInfo = {};
    this.data.propertyInfo = {};
    this.data.productPackageInfo = {};
    this.data.underwritingInfo = {};
    this.data.insuranceCarrierInfo = {};
    this.data.modalFeeInfo = {};
    this.data.termFeeInfo = {};
    this.data.checkProcessingFeeInfo = {};
    this.data.paperlessInfo = {};
    this.data.paymentNotices = {};
    this.data.securityQuestions = [];
    this.data.insuranceInfo = {
      authInfo: {},
      quoteID: 0,
      productGroupID: 0,
      selectedOptions: {
        deductibleInfo: {},
        endorsementInfo: [],
      },
      underwritingResponse: [],
      residentsInfo: [],
      taxInfo: [],
      unitID: 0,
      isMailingAddressSameAsUnitAddress: true,
      isCarrierAPIIntegrated: false,
      cardType: '',
      paymentMethod: '',
      paymentFrequency: '',
      quoteRequestSource: '',
    };
    this.data.aBTests = [];
    this.data.retrieveQuoteID = '';
    this.data.resetToken = false;
    this.data.allowDeclineInsurance = true;
    this.data.insuranceRequired = false;
    this.data.allowThirdParty = true;
    this.data.noInsurance = false;
    this.data.beyondEffectiveDate = false;
    this.data.propertyMoratorium = false;
    this.data.customErrorMessage = '';
    this.data.effectiveDateIsToday = false;
    this.data.paymentSuccessful = false;
    this.data.followMe = null;
    this.data.steps = [];
    this.data.receivedQuote = null;
    this.data.states = [
      {
        StateName: 'Alaska',
        Abbr: 'AK',
      },
      {
        StateName: 'Alabama',
        Abbr: 'AL',
      },
      {
        StateName: 'Arkansas',
        Abbr: 'AR',
      },
      {
        StateName: 'Arizona',
        Abbr: 'AZ',
      },
      {
        StateName: 'California',
        Abbr: 'CA',
      },
      {
        StateName: 'Colorado',
        Abbr: 'CO',
      },
      {
        StateName: 'Connecticut',
        Abbr: 'CT',
      },
      {
        StateName: 'District of Columbia',
        Abbr: 'DC',
      },
      {
        StateName: 'Delaware',
        Abbr: 'DE',
      },
      {
        StateName: 'Florida',
        Abbr: 'FL',
      },
      {
        StateName: 'Federated States of Micronesia',
        Abbr: 'FM',
      },
      {
        StateName: 'Georgia',
        Abbr: 'GA',
      },
      {
        StateName: 'Guam',
        Abbr: 'GU',
      },
      {
        StateName: 'Hawaii',
        Abbr: 'HI',
      },
      {
        StateName: 'Iowa',
        Abbr: 'IA',
      },
      {
        StateName: 'Idaho',
        Abbr: 'ID',
      },
      {
        StateName: 'Illinois',
        Abbr: 'IL',
      },
      {
        StateName: 'Indiana',
        Abbr: 'IN',
      },
      {
        StateName: 'Kansas',
        Abbr: 'KS',
      },
      {
        StateName: 'Kentucky',
        Abbr: 'KY',
      },
      {
        StateName: 'Louisiana',
        Abbr: 'LA',
      },
      {
        StateName: 'Massachusetts',
        Abbr: 'MA',
      },
      {
        StateName: 'Maryland',
        Abbr: 'MD',
      },
      {
        StateName: 'Maine',
        Abbr: 'ME',
      },
      {
        StateName: 'Marshall Islands',
        Abbr: 'MH',
      },
      {
        StateName: 'Michigan',
        Abbr: 'MI',
      },
      {
        StateName: 'Minnesota',
        Abbr: 'MN',
      },
      {
        StateName: 'Missouri',
        Abbr: 'MO',
      },
      {
        StateName: 'Mississippi',
        Abbr: 'MS',
      },
      {
        StateName: 'Montana',
        Abbr: 'MT',
      },
      {
        StateName: 'North Carolina',
        Abbr: 'NC',
      },
      {
        StateName: 'North Dakota',
        Abbr: 'ND',
      },
      {
        StateName: 'Nebraska',
        Abbr: 'NE',
      },
      {
        StateName: 'New Hampshire',
        Abbr: 'NH',
      },
      {
        StateName: 'New Jersey',
        Abbr: 'NJ',
      },
      {
        StateName: 'New Mexico',
        Abbr: 'NM',
      },
      {
        StateName: 'Nevada',
        Abbr: 'NV',
      },
      {
        StateName: 'New York',
        Abbr: 'NY',
      },
      {
        StateName: 'Ohio',
        Abbr: 'OH',
      },
      {
        StateName: 'Oklahoma',
        Abbr: 'OK',
      },
      {
        StateName: 'Oregon',
        Abbr: 'OR',
      },
      {
        StateName: 'Pennsylvania',
        Abbr: 'PA',
      },
      {
        StateName: 'Puerto Rico',
        Abbr: 'PR',
      },
      {
        StateName: 'Rhode Island',
        Abbr: 'RI',
      },
      {
        StateName: 'South Carolina',
        Abbr: 'SC',
      },
      {
        StateName: 'South Dakota',
        Abbr: 'SD',
      },
      {
        StateName: 'Tennessee',
        Abbr: 'TN',
      },
      {
        StateName: 'Texas',
        Abbr: 'TX',
      },
      {
        StateName: 'Utah',
        Abbr: 'UT',
      },
      {
        StateName: 'Virginia',
        Abbr: 'VA',
      },
      {
        StateName: 'Virgin Islands',
        Abbr: 'VI',
      },
      {
        StateName: 'Vermont',
        Abbr: 'VT',
      },
      {
        StateName: 'Washington',
        Abbr: 'WA',
      },
      {
        StateName: 'Wisconsin',
        Abbr: 'WI',
      },
      {
        StateName: 'West Virginia',
        Abbr: 'WV',
      },
      {
        StateName: 'Wyoming',
        Abbr: 'WY',
      },
    ];
    this.data.countries = [
      { name: 'Afghanistan', code: 'AF' },
      { name: 'Åland Islands', code: 'AX' },
      { name: 'Albania', code: 'AL' },
      { name: 'Algeria', code: 'DZ' },
      { name: 'American Samoa', code: 'AS' },
      { name: 'Andorra', code: 'AD' },
      { name: 'Angola', code: 'AO' },
      { name: 'Anguilla', code: 'AI' },
      { name: 'Antarctica', code: 'AQ' },
      { name: 'Antigua and Barbuda', code: 'AG' },
      { name: 'Argentina', code: 'AR' },
      { name: 'Armenia', code: 'AM' },
      { name: 'Aruba', code: 'AW' },
      { name: 'Australia', code: 'AU' },
      { name: 'Austria', code: 'AT' },
      { name: 'Azerbaijan', code: 'AZ' },
      { name: 'Bahamas', code: 'BS' },
      { name: 'Bahrain', code: 'BH' },
      { name: 'Bangladesh', code: 'BD' },
      { name: 'Barbados', code: 'BB' },
      { name: 'Belarus', code: 'BY' },
      { name: 'Belgium', code: 'BE' },
      { name: 'Belize', code: 'BZ' },
      { name: 'Benin', code: 'BJ' },
      { name: 'Bermuda', code: 'BM' },
      { name: 'Bhutan', code: 'BT' },
      { name: 'Bolivia', code: 'BO' },
      { name: 'Bosnia and Herzegovina', code: 'BA' },
      { name: 'Botswana', code: 'BW' },
      { name: 'Bouvet Island', code: 'BV' },
      { name: 'Brazil', code: 'BR' },
      { name: 'British Indian Ocean Territory', code: 'IO' },
      { name: 'Brunei Darussalam', code: 'BN' },
      { name: 'Bulgaria', code: 'BG' },
      { name: 'Burkina Faso', code: 'BF' },
      { name: 'Burundi', code: 'BI' },
      { name: 'Cambodia', code: 'KH' },
      { name: 'Cameroon', code: 'CM' },
      { name: 'Canada', code: 'CA' },
      { name: 'Cape Verde', code: 'CV' },
      { name: 'Cayman Islands', code: 'KY' },
      { name: 'Central African Republic', code: 'CF' },
      { name: 'Chad', code: 'TD' },
      { name: 'Chile', code: 'CL' },
      { name: 'China', code: 'CN' },
      { name: 'Christmas Island', code: 'CX' },
      { name: 'Cocos (Keeling) Islands', code: 'CC' },
      { name: 'Colombia', code: 'CO' },
      { name: 'Comoros', code: 'KM' },
      { name: 'Congo', code: 'CG' },
      { name: 'Congo, The Democratic Republic of the', code: 'CD' },
      { name: 'Cook Islands', code: 'CK' },
      { name: 'Costa Rica', code: 'CR' },
      { name: `Cote D'Ivoire`, code: 'CI' },
      { name: 'Croatia', code: 'HR' },
      { name: 'Cuba', code: 'CU' },
      { name: 'Cyprus', code: 'CY' },
      { name: 'Czech Republic', code: 'CZ' },
      { name: 'Denmark', code: 'DK' },
      { name: 'Djibouti', code: 'DJ' },
      { name: 'Dominica', code: 'DM' },
      { name: 'Dominican Republic', code: 'DO' },
      { name: 'Ecuador', code: 'EC' },
      { name: 'Egypt', code: 'EG' },
      { name: 'El Salvador', code: 'SV' },
      { name: 'Equatorial Guinea', code: 'GQ' },
      { name: 'Eritrea', code: 'ER' },
      { name: 'Estonia', code: 'EE' },
      { name: 'Ethiopia', code: 'ET' },
      { name: 'Falkland Islands (Malvinas)', code: 'FK' },
      { name: 'Faroe Islands', code: 'FO' },
      { name: 'Fiji', code: 'FJ' },
      { name: 'Finland', code: 'FI' },
      { name: 'France', code: 'FR' },
      { name: 'French Guiana', code: 'GF' },
      { name: 'French Polynesia', code: 'PF' },
      { name: 'French Southern Territories', code: 'TF' },
      { name: 'Gabon', code: 'GA' },
      { name: 'Gambia', code: 'GM' },
      { name: 'Georgia', code: 'GE' },
      { name: 'Germany', code: 'DE' },
      { name: 'Ghana', code: 'GH' },
      { name: 'Gibraltar', code: 'GI' },
      { name: 'Greece', code: 'GR' },
      { name: 'Greenland', code: 'GL' },
      { name: 'Grenada', code: 'GD' },
      { name: 'Guadeloupe', code: 'GP' },
      { name: 'Guam', code: 'GU' },
      { name: 'Guatemala', code: 'GT' },
      { name: 'Guernsey', code: 'GG' },
      { name: 'Guinea', code: 'GN' },
      { name: 'Guinea-Bissau', code: 'GW' },
      { name: 'Guyana', code: 'GY' },
      { name: 'Haiti', code: 'HT' },
      { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
      { name: 'Holy See (Vatican City State)', code: 'VA' },
      { name: 'Honduras', code: 'HN' },
      { name: 'Hong Kong', code: 'HK' },
      { name: 'Hungary', code: 'HU' },
      { name: 'Iceland', code: 'IS' },
      { name: 'India', code: 'IN' },
      { name: 'Indonesia', code: 'ID' },
      { name: 'Iran, Islamic Republic Of', code: 'IR' },
      { name: 'Iraq', code: 'IQ' },
      { name: 'Ireland', code: 'IE' },
      { name: 'Isle of Man', code: 'IM' },
      { name: 'Israel', code: 'IL' },
      { name: 'Italy', code: 'IT' },
      { name: 'Jamaica', code: 'JM' },
      { name: 'Japan', code: 'JP' },
      { name: 'Jersey', code: 'JE' },
      { name: 'Jordan', code: 'JO' },
      { name: 'Kazakhstan', code: 'KZ' },
      { name: 'Kenya', code: 'KE' },
      { name: 'Kiribati', code: 'KI' },
      { name: `Korea, Democratic People's Republic of`, code: 'KP' },
      { name: 'Korea, Republic of', code: 'KR' },
      { name: 'Kuwait', code: 'KW' },
      { name: 'Kyrgyzstan', code: 'KG' },
      { name: `Lao People's Democratic Republic`, code: 'LA' },
      { name: 'Latvia', code: 'LV' },
      { name: 'Lebanon', code: 'LB' },
      { name: 'Lesotho', code: 'LS' },
      { name: 'Liberia', code: 'LR' },
      { name: 'Libyan Arab Jamahiriya', code: 'LY' },
      { name: 'Liechtenstein', code: 'LI' },
      { name: 'Lithuania', code: 'LT' },
      { name: 'Luxembourg', code: 'LU' },
      { name: 'Macao', code: 'MO' },
      { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
      { name: 'Madagascar', code: 'MG' },
      { name: 'Malawi', code: 'MW' },
      { name: 'Malaysia', code: 'MY' },
      { name: 'Maldives', code: 'MV' },
      { name: 'Mali', code: 'ML' },
      { name: 'Malta', code: 'MT' },
      { name: 'Marshall Islands', code: 'MH' },
      { name: 'Martinique', code: 'MQ' },
      { name: 'Mauritania', code: 'MR' },
      { name: 'Mauritius', code: 'MU' },
      { name: 'Mayotte', code: 'YT' },
      { name: 'Mexico', code: 'MX' },
      { name: 'Micronesia, Federated States of', code: 'FM' },
      { name: 'Moldova, Republic of', code: 'MD' },
      { name: 'Monaco', code: 'MC' },
      { name: 'Mongolia', code: 'MN' },
      { name: 'Montserrat', code: 'MS' },
      { name: 'Morocco', code: 'MA' },
      { name: 'Mozambique', code: 'MZ' },
      { name: 'Myanmar', code: 'MM' },
      { name: 'Namibia', code: 'NA' },
      { name: 'Nauru', code: 'NR' },
      { name: 'Nepal', code: 'NP' },
      { name: 'Netherlands', code: 'NL' },
      { name: 'Netherlands Antilles', code: 'AN' },
      { name: 'New Caledonia', code: 'NC' },
      { name: 'New Zealand', code: 'NZ' },
      { name: 'Nicaragua', code: 'NI' },
      { name: 'Niger', code: 'NE' },
      { name: 'Nigeria', code: 'NG' },
      { name: 'Niue', code: 'NU' },
      { name: 'Norfolk Island', code: 'NF' },
      { name: 'Northern Mariana Islands', code: 'MP' },
      { name: 'Norway', code: 'NO' },
      { name: 'Oman', code: 'OM' },
      { name: 'Pakistan', code: 'PK' },
      { name: 'Palau', code: 'PW' },
      { name: 'Palestinian Territory, Occupied', code: 'PS' },
      { name: 'Panama', code: 'PA' },
      { name: 'Papua New Guinea', code: 'PG' },
      { name: 'Paraguay', code: 'PY' },
      { name: 'Peru', code: 'PE' },
      { name: 'Philippines', code: 'PH' },
      { name: 'Pitcairn', code: 'PN' },
      { name: 'Poland', code: 'PL' },
      { name: 'Portugal', code: 'PT' },
      { name: 'Puerto Rico', code: 'PR' },
      { name: 'Qatar', code: 'QA' },
      { name: 'Reunion', code: 'RE' },
      { name: 'Romania', code: 'RO' },
      { name: 'Russian Federation', code: 'RU' },
      { name: 'Rwanda', code: 'RW' },
      { name: 'Saint Helena', code: 'SH' },
      { name: 'Saint Kitts and Nevis', code: 'KN' },
      { name: 'Saint Lucia', code: 'LC' },
      { name: 'Saint Pierre and Miquelon', code: 'PM' },
      { name: 'Saint Vincent and the Grenadines', code: 'VC' },
      { name: 'Samoa', code: 'WS' },
      { name: 'San Marino', code: 'SM' },
      { name: 'Sao Tome and Principe', code: 'ST' },
      { name: 'Saudi Arabia', code: 'SA' },
      { name: 'Senegal', code: 'SN' },
      { name: 'Serbia and Montenegro', code: 'CS' },
      { name: 'Seychelles', code: 'SC' },
      { name: 'Sierra Leone', code: 'SL' },
      { name: 'Singapore', code: 'SG' },
      { name: 'Slovakia', code: 'SK' },
      { name: 'Slovenia', code: 'SI' },
      { name: 'Solomon Islands', code: 'SB' },
      { name: 'Somalia', code: 'SO' },
      { name: 'South Africa', code: 'ZA' },
      { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
      { name: 'Spain', code: 'ES' },
      { name: 'Sri Lanka', code: 'LK' },
      { name: 'Sudan', code: 'SD' },
      { name: 'Suriname', code: 'SR' },
      { name: 'Svalbard and Jan Mayen', code: 'SJ' },
      { name: 'Swaziland', code: 'SZ' },
      { name: 'Sweden', code: 'SE' },
      { name: 'Switzerland', code: 'CH' },
      { name: 'Syrian Arab Republic', code: 'SY' },
      { name: 'Taiwan, Province of China', code: 'TW' },
      { name: 'Tajikistan', code: 'TJ' },
      { name: 'Tanzania, United Republic of', code: 'TZ' },
      { name: 'Thailand', code: 'TH' },
      { name: 'Timor-Leste', code: 'TL' },
      { name: 'Togo', code: 'TG' },
      { name: 'Tokelau', code: 'TK' },
      { name: 'Tonga', code: 'TO' },
      { name: 'Trinidad and Tobago', code: 'TT' },
      { name: 'Tunisia', code: 'TN' },
      { name: 'Turkey', code: 'TR' },
      { name: 'Turkmenistan', code: 'TM' },
      { name: 'Turks and Caicos Islands', code: 'TC' },
      { name: 'Tuvalu', code: 'TV' },
      { name: 'Uganda', code: 'UG' },
      { name: 'Ukraine', code: 'UA' },
      { name: 'United Arab Emirates', code: 'AE' },
      { name: 'United Kingdom', code: 'GB' },
      { name: 'United States', code: 'US' },
      { name: 'United States Minor Outlying Islands', code: 'UM' },
      { name: 'Uruguay', code: 'UY' },
      { name: 'Uzbekistan', code: 'UZ' },
      { name: 'Vanuatu', code: 'VU' },
      { name: 'Venezuela', code: 'VE' },
      { name: 'Vietnam', code: 'VN' },
      { name: 'Virgin Islands, British', code: 'VG' },
      { name: 'Virgin Islands, U.S.', code: 'VI' },
      { name: 'Wallis and Futuna', code: 'WF' },
      { name: 'Western Sahara', code: 'EH' },
      { name: 'Yemen', code: 'YE' },
      { name: 'Zambia', code: 'ZM' },
      { name: 'Zimbabwe', code: 'ZW' },
    ];
    this.data.reportWidgetEventQueue = [];
  }

  public checkMaintenance(): void {
    if (this.data.paymentMaintenance) {
      this.GetQuoteDetailsService.getWidgetSettings(this.data.settingsData).subscribe(
        (data) => {
          console.log('DATA RESPONSE: ', data);
          // Get the latest value for the paymentMaintenance
          this.data.paymentMaintenance = data.paymentMaintenance;
          /** Google Analytics Event */
          this.trackEvents('Insurance Widget', 'Success Reloading Maintenance Setting', this.data.insuranceInfo.quoteRequestSource);
        },
        (err) => {
          /** Google Analytics Event */
          this.trackEvents('Insurance Widget', 'Error Reloading Maintenance Setting', this.data.insuranceInfo.quoteRequestSource);
        }
      );
    }
  }

  public trackEvents(eventCategory: string, eventAction: string, eventLabel: string, variant: string = ''): void {
    // Send event data to Google Analytics Tracking
    this.GoogleAnalyticsEventsService.sendEvent(eventCategory, eventAction, eventLabel, variant);
    // Check for previous events that were not sent due to token refresh
    if (this.data.reportWidgetEventQueue.length > 0 && !this.data.resetToken) {
      for (let i = this.data.reportWidgetEventQueue.length - 1; i >= 0; i--) {
        this.submitWidgetEvent(this.data.reportWidgetEventQueue[i]);
        this.data.reportWidgetEventQueue.splice(i, 1);
      }
    }
    // Prepare new event payload
    if (this.data.propertyInfo.propertyId) {
      // Track events in our own reporting Database
      const reportData = {
        propertyID: this.data.propertyInfo.propertyId,
        companyID: null,
        userID: this.data.sessionPrimaryResidentInfo.externalResID,
        eventCategoryName: eventCategory,
        eventActionName: eventAction,
        eventLabelName: eventLabel,
        sessionID: this.cookieService.get('_gid'),
        gaTrackingID: this.cookieService.get('_ga'),
        applicationSource: this.data.insuranceInfo.quoteRequestSource,
      };
      // Submit the event payload
      this.submitWidgetEvent(reportData);
    }
  }

  submitWidgetEvent = (reportData) => {
    this.GetQuoteDetailsService.reportWidgetEvents(reportData).subscribe(
      (data) => {
        console.log('Report Event Success', data);
      },
      (err) => {
        if (err.status === 401) {
          // Add request payload to the beginning of the event queue
          this.data.reportWidgetEventQueue.unshift(reportData);
        } else {
          console.log('Report Event Failed', err);
        }
      }
    );
  }

  validateLiabilityAmount = (amount: number): boolean => amount && amount > 0;

  validatePostalCode = (postalCode: string): boolean => /^[0-9]{5}(-[0-9]{4})?$/.test(postalCode);

  validateEmail = (email: string): boolean =>
    /^(?:[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(
      email
    )

  validateUsername = (username: string): boolean =>
    /^[a-zA-Z0-9\`\~\{\}\=\<\>\^\|\#\$\%\&amp;\@\*\(\)\-_\\&quot;\+\]\[\'\;\:\?.\,\!\/]+$/.test(username) && username?.length >= 6

  validatePhone = (phoneNumber: string): boolean => phoneNumber.length >= 10 && phoneNumber.length < 15;

  validateName = (name: string): boolean => /^[a-zA-Z\.\,\-\ ]+$/.test(name) && name?.length >= 2;

  validatePassword = (password: string): boolean => password && password.length >= 8;

  validateSecurityCode(cvv: string, cardNumber: string = ''): boolean {
    if (cvv) {
      let cvvLength: number;
      // If card is AMEX validate for 4 digits otherwise 3 digits
      this.getCardType(cardNumber) === 'AmericanExpress' ? (cvvLength = 4) : (cvvLength = 3);
      return cvv.length === cvvLength;
    }
    return this.isLDAppSource() || false;
  }

  getCardType = (ccNumber) => {
    let cardType = '';
    if (ccNumber.length === 16) {
      if (+ccNumber.substring(0, 1) === 4) {
        cardType = 'Visa';
      } else if (+ccNumber.substring(0, 2) >= 51 && +ccNumber.substring(0, 2) <= 55) {
        cardType = 'MasterCard';
      } else if (+ccNumber.substring(0, 2) >= 22 && +ccNumber.substring(0, 2) <= 27) {
        cardType = 'MasterCard';
      } else if (+ccNumber.substring(0, 4) === 6011 || +ccNumber.substring(0, 2) === 65) {
        cardType = 'Discover';
      } else if (+ccNumber.substring(0, 6) >= 622126 && +ccNumber.substring(0, 6) <= 622925) {
        cardType = 'Discover';
      } else if (+ccNumber.substring(0, 3) >= 644 && +ccNumber.substring(0, 3) <= 649) {
        cardType = 'Discover';
      }
    } else if (ccNumber.length === 15) {
      if (+ccNumber.substring(0, 2) === 34 || +ccNumber.substring(0, 2) === 37) {
        cardType = 'AmericanExpress';
      }
    }
    return cardType;
  }

  ccMod10Validation = (ccNumber) => {
    const doubled = [];
    let total = 0;
    for (let i = ccNumber.length - 2; i >= 0; i = i - 2) {
      let multiply = 2 * ccNumber[i];
      if (multiply.toString().length > 1) {
        multiply = parseInt(multiply.toString().charAt(0), 10) + parseInt(multiply.toString(10).charAt(1), 10);
      }
      doubled.push(multiply);
    }

    for (let i = ccNumber.length % 2 === 0 ? 1 : 0; i < ccNumber.length; i = i + 2) {
      total += parseInt(ccNumber[i], 10);
    }

    for (const num of doubled) {
      total += num;
    }

    if (total % 10 === 0) {
      console.log('CC MOD10 Validated');
      return true;
    }
    console.log('CC MOD10 Invalidated');
    return false;
  }

  isolatePaymentMethod = (paymentMethodString: string) =>
    paymentMethodString.includes('Bank Account') ? 'Bank Account' : paymentMethodString

  getPaymentMethodID(paymentDesc: string): string {
    const paymentType = paymentDesc.split('(', 1);
    switch (this.isolatePaymentMethod(paymentType[0].trim())) {
      case 'Bank Account': // ACH
        return 'ACH';
      case 'AmericanExpress': // AMEX
        return 'CC1';
      case 'Discover': // DISC
        return 'CC2';
      case 'MasterCard': // MC
        return 'CC3';
      case 'Visa': // VISA
        return 'CC4';
      default:
        // default block statement;
        return '0';
    }
  }

  adjustFrequencyPremium = (premium, actions) => {
    let adjustedPremium = premium;
    let removeTaxes = 0;
    let removeEndorsements = 0;
    let removeFees = 0;

    for (const action of actions) {
      // Remove Taxes
      if (action === 'taxes') {
        for (const taxItem of this.data.userActions.paymentFrequency.paymentFrequencyResponse.taxPremiumInfo) {
          removeTaxes += this.frequencyPremiumCalc(taxItem.taxPremium, taxItem.taxInvoiceApproach);
        }
      }
      // Remove Endorsements
      if (action === 'endorsements') {
        for (const endorsementItem of this.data.userActions.payment.invoiceDetails.endorsements) {
          removeEndorsements += this.frequencyPremiumCalc(endorsementItem.optionPremium);
        }
      }
      // Remove Fees
      if (action === 'fees') {
        if (this.data.userActions.payment.invoiceDetails.termFee) {
          removeFees += this.data.userActions.payment.invoiceDetails.termFee;
        }
        if (this.data.userActions.payment.invoiceDetails.modalFee > 0) {
          removeFees += this.data.userActions.payment.invoiceDetails.modalFee;
        }
      }
    }

    adjustedPremium -= removeTaxes + removeEndorsements + removeFees;
    return adjustedPremium;
  }

  getPackagePremium(packageObject) {
    let packagePremium = 0;
    let deductiblePremium = 0;
    for (let i = 0; i < packageObject.productInfo.length; i++) {
      packagePremium += packageObject.productInfo[i].optionPremium;
    }
    if (packageObject.deductibleInfo) {
      for (let j = 0; j < packageObject.deductibleInfo.length; j++) {
        if (packageObject.deductibleInfo[j].defaultOption === true) {
          deductiblePremium = packageObject.deductibleInfo[j].optionPremium;
          return packagePremium + deductiblePremium;
        }
      }
    } else {
      return packagePremium;
    }
  }

  getPackageAndEndorsementTotal = (pricingPackage) => {
    let packageTotalPrice = 0;
    packageTotalPrice += pricingPackage.basePremium;
    for (const endorsement of pricingPackage.endorsements) {
      packageTotalPrice += endorsement.optionPremium;
    }
    return packageTotalPrice;
  }

  getFrequencyPrice = (optionPremium: any, paymentFrequency: any = '') => {
    switch (paymentFrequency) {
      case 'Annually':
        return optionPremium;
      case 'SemiAnnually':
        return optionPremium / 2;
      case 'Quarterly':
        return optionPremium / 4;
      case 'Monthly':
        return optionPremium / 12;
      default:
        return optionPremium / 12;
    }
  }

  frequencyPremiumCalc = (annualPremium, action = 'split') => {
    if (action !== 'upfront') {
      switch (this.data.insuranceInfo.paymentFrequency) {
        case 'Annually':
          return annualPremium;
        case 'SemiAnnually':
          return Math.abs(annualPremium / 2);
        case 'Quarterly':
          return Math.abs(annualPremium / 4);
        case 'Monthly':
          return Math.abs(annualPremium / 12);
        default:
          return annualPremium;
      }
    } else {
      return annualPremium;
    }
  }

  getEndorsementData(poaid, fieldName, coverageObject) {
    const endorsementData = coverageObject.endorsementDetails ? coverageObject.endorsementDetails : coverageObject.specialDetailsInfo;
    for (let i = 0; i < endorsementData.length; i++) {
      const endorsementOption = endorsementData[i];
      if (endorsementOption.poaid === poaid) {
        return endorsementOption[fieldName];
      }
    }
  }

  pullEndorsementCarrierData(name, poaid, planPackage) {
    console.log('PLAN PACKAGE: ', planPackage);
    const packageObj = {
      poaid: poaid,
      optionID: this.getEndorsementData(poaid, 'optionID', planPackage),
      optionLimit: this.getEndorsementData(poaid, 'optionLimit', planPackage),
      carrierCoverageCode: this.getEndorsementData(poaid, 'carrierCoverageCode', planPackage),
      carrierTermCode: this.getEndorsementData(poaid, 'carrierTermCode', planPackage),
      optionPremium: this.getEndorsementData(poaid, 'optionPremium', planPackage),
      name: name,
      detail: this.getEndorsementData(poaid, 'productOptionShortDescription', planPackage),
      toolTipText: planPackage.toolTipText,
    };
    return packageObj;
  }

  checkForSpecials(packageData) {
    if (packageData.specialInfo && packageData.specialInfo.length > 0) {
      for (let j = 0; j < packageData.specialInfo.length; j++) {
        // Wind Hail Exemption Only for LD Call Center
        if (this.isLDAppSource()) {
          if (packageData.specialInfo[j].endorsementCode === 'HUVJ') {
            // Pull Wind Hail Exemption Option
            this.data.userActions.additionalCoverages.windHail[0] = packageData.specialInfo[j];
            console.log('Added the Wind Hail Exmeption to the Endorsements');
          }
        }
      }
    }
  }

  updateEndorsement(action, name, poaid, coverageObject) {
    if (action === 'add') {
      const endorsement = this.pullEndorsementCarrierData(name, poaid, coverageObject);
      this.data.insuranceInfo.selectedOptions.endorsementInfo.push(endorsement);
      // Broadcast the package changes
      this.GetQuoteDetailsService.broadcastPackagePrice(this.data.insuranceInfo.selectedOptions, '');
    } else if (action === 'remove') {
      for (let i = 0; i < this.data.insuranceInfo.selectedOptions.endorsementInfo.length; i++) {
        const endorsement = this.data.insuranceInfo.selectedOptions.endorsementInfo[i];
        if (endorsement.name === name) {
          this.data.insuranceInfo.selectedOptions.endorsementInfo.splice(i, 1);
        }
      }
      // Broadcast the package changes
      this.GetQuoteDetailsService.broadcastPackagePrice(this.data.insuranceInfo.selectedOptions, '');
    }
    console.log('INSURANCE INFO -- ' + action + ' ENDORSEMENT OPTION: ', this.data.insuranceInfo);
  }

  endorsementChanged(coverageOption) {
    console.log('Repopulating Coverage Option: ', coverageOption);
    if (coverageOption.endorsementSelected) {
      // Remove the endorsement
      this.updateEndorsement('remove', coverageOption.endorsementName, coverageOption.endorsementSelection, coverageOption);
      // Add the endorsement back with the corerect option information
      this.updateEndorsement('add', coverageOption.endorsementName, coverageOption.endorsementSelection, coverageOption);
      /** Google Analytics Event */
      this.trackEvents(
        'Endorsement Selection',
        coverageOption.endorsementName + ' Endorsement Option Changed',
        this.data.insuranceInfo.quoteRequestSource
      );
      console.log('ENDORSEMENT UPDATED : Changing the value for endorsement based on the poaid change.');
      // Broadcast the package changes
      this.GetQuoteDetailsService.broadcastPackagePrice(this.data.insuranceInfo.selectedOptions, '');
    }
  }

  setSelections(coverageGroup, prevCoverages = null) {
    for (let j = 0; j < coverageGroup.length; j++) {
      const additionalCoverage = coverageGroup[j];
      const endorsements = additionalCoverage.endorsementDetails
        ? additionalCoverage.endorsementDetails
        : additionalCoverage.specialDetailsInfo[0];
      additionalCoverage.endorsementSelection = endorsements.poaid;
      if (prevCoverages && prevCoverages.length > 0 && prevCoverages[j]?.endorsementSelected) {
        additionalCoverage.endorsementSelected = true;
        if (prevCoverages[j].endorsementDetails) {
          for (let k = 0; k < prevCoverages[j].endorsementDetails.length; k++) {
            const prevEndorsementOption = prevCoverages[j].endorsementDetails[k];
            if (prevEndorsementOption.poaid === prevCoverages[j].endorsementSelection) {
              const productOptionShortDescription = prevEndorsementOption.productOptionShortDescription;
              for (let m = 0; m < endorsements.length; m++) {
                const endorsementOption = endorsements[m];
                if (endorsementOption.productOptionShortDescription === productOptionShortDescription) {
                  additionalCoverage.endorsementSelection = endorsementOption.poaid;
                }
              }
            }
          }
        } else if (prevCoverages[j].specialDetailsInfo) {
          for (let k = 0; k < prevCoverages[j].specialDetailsInfo.length; k++) {
            const prevEndorsementOption = prevCoverages[j].specialDetailsInfo[k];
            if (prevEndorsementOption.poaid === prevCoverages[j].endorsementSelection) {
              const productOptionShortDescription = prevEndorsementOption.productOptionShortDescription;
              for (let m = 0; m < endorsements.length; m++) {
                const endorsementOption = endorsements[m];
                if (endorsementOption.productOptionShortDescription === productOptionShortDescription) {
                  additionalCoverage.endorsementSelection = endorsementOption.poaid;
                }
              }
            }
          }
        }
        this.endorsementChanged(additionalCoverage);
      } else {
        additionalCoverage.endorsementSelected = false;
      }
    }
  }

  findInvalidFields = () => {
    setTimeout(() => {
      /** Scroll to the top of the open panel */
      if (document.querySelector('.invalid-field')) {
        // Pull all invalid fields for GA tracking purposes
        this.trackAllInvalidFields();
        const scrollMarker = document.createElement('div');
        scrollMarker.setAttribute('class', 'invalid-field-marker');
        let topOffset = document.querySelector('.invalid-field').getBoundingClientRect().top - document.body.getBoundingClientRect().top;
        if (topOffset < 160) {
          topOffset = 160;
        }
        scrollMarker.style.top = (topOffset - 160).toString() + 'px';
        document.body.appendChild(scrollMarker);
        document.querySelector('.invalid-field-marker').scrollIntoView({ behavior: 'smooth' });
        // Remove the marker after scrolling to the proper location
        document.body.removeChild(scrollMarker);
      }
    }, 250);
  }

  trackAllInvalidFields = () => {
    const invalidFields = document.querySelectorAll('.invalid-field');
    // console.log("INVALID FIELDS: ", invalidFields);
    for (let i = 0; i < invalidFields.length; i++) {
      if (invalidFields[i]['name']) {
        console.log('Invalid Item: ', this.data.steps[this.data.currentStep]?.name + '-' + invalidFields[i]['name']);
        /** Google Analytics Event */
        this.trackEvents(
          'Field Validation Errors',
          this.data.steps[this.data.currentStep]?.name + ' - ' + invalidFields[i]['name'],
          this.data.insuranceInfo.quoteRequestSource
        );
      }
    }
  }

  getPrimaryResident = (residentsInfo) => {
    const primaryResident = residentsInfo.filter((resident) => resident.isPrimaryResident);
    return primaryResident[0];
  }

  trimInitialSpace(str) {
    if (str.charAt(0) === ' ') {
      return str.substr(1);
    } else {
      return str;
    }
  }

  truncate(str: string, chars: number = 250) {
    return str.substr(0, chars) + '...';
  }

  isNumber(value) {
    if (Number(value)) {
      return true;
    } else {
      return false;
    }
  }

  convertToJSDate(date) {
    if (date.month && date.day && date.year) {
      return new Date(date.month + '/' + date.day + '/' + date.year);
    }
    if (typeof date === 'string') {
      return new Date(date);
    }
    return '';
  }

  getMonths() {
    return [
      { name: 'January', code: '1' },
      { name: 'February', code: '2' },
      { name: 'March', code: '3' },
      { name: 'April', code: '4' },
      { name: 'May', code: '5' },
      { name: 'June', code: '6' },
      { name: 'July', code: '7' },
      { name: 'August', code: '8' },
      { name: 'September', code: '9' },
      { name: 'October', code: '10' },
      { name: 'November', code: '11' },
      { name: 'December', code: '12' },
    ];
  }

  getYears() {
    const currDate = new Date();
    const years = [];
    for (let i = 0; i < 10; i++) {
      const expYear = {
        name: currDate.getFullYear() + i,
        code: currDate.getFullYear() + i,
      };
      years.push(expYear);
    }
    return years;
  }

  getStates = () => this.data.states;

  getCountries = () => this.data.countries;

  /** Service to scrub invalid characters out of input fields */
  scrubCharacters($event, type) {
    let CUSTOM_REGEX, JUST_NUMBERS_REGEX;

    switch (type) {
      case 'zipcode': // clean zipcode
        CUSTOM_REGEX = new RegExp('[^0-9-]', 'g');
        $event.target.value = $event.target.value.replace(CUSTOM_REGEX, '');
        return $event.target.value;

      case 'number': // clean number
        CUSTOM_REGEX = new RegExp('[^0-9]', 'g');
        $event.target.value = $event.target.value.replace(CUSTOM_REGEX, '');
        return $event.target.value;

      case 'name': // clean name
        CUSTOM_REGEX = new RegExp('[^a-zA-Z,-. ]', 'g');
        $event.target.value = $event.target.value.replace(CUSTOM_REGEX, '');
        $event.target.value = this.trimInitialSpace($event.target.value);
        return $event.target.value;

      case 'phone': // clean phone
        CUSTOM_REGEX = new RegExp('[^0-9-()+ ]', 'g');
        JUST_NUMBERS_REGEX = new RegExp('[^0-9]', 'g');
        $event.target.value = $event.target.value.replace(CUSTOM_REGEX, '');
        const numbers = $event.target.value.replace(JUST_NUMBERS_REGEX, '');
        if (numbers.length > 14) {
          $event.target.value = $event.target.value.slice(0, 15);
        }
        return $event.target.value.replace(/\D/g, '');

      case 'numberOrLetter': // clean numberORLetter
        CUSTOM_REGEX = new RegExp('[^0-9a-zA-Z ]', 'g');
        $event.target.value = $event.target.value.replace(CUSTOM_REGEX, '');
        $event.target.value = this.trimInitialSpace($event.target.value);
        return $event.target.value;

      case 'username': // clean numberORLetter
        CUSTOM_REGEX = new RegExp('[/\\\\]', 'g');
        $event.target.value = $event.target.value.replace(CUSTOM_REGEX, '');
        $event.target.value = this.trimInitialSpace($event.target.value);
        return $event.target.value;

      default:
      // Nothing
    }
  }

  addStep(name) {
    const addStep = { name: name, disabled: true };
    let position = 0;
    if (name === 'additionalCoverages') {
      position = 1;
    }
    this.data.steps.splice(position, 0, addStep);
  }

  removeStep(name) {
    console.log('REMOVING STEP');
    for (let i = 0; i < this.data.steps.length; i++) {
      if (name === this.data.steps[i].name) {
        this.data.steps.splice(i, 1);
      }
    }
    console.log('REMOVED STEP: ', this.data.steps);
  }

  pullPackageCarrierData(planPackage) {
    const packageObj = {
      poaid: planPackage.poaid,
      optionID: planPackage.optionID,
      optionLimit: planPackage.optionLimit,
      carrierCoverageCode: planPackage.carrierCoverageCode,
      carrierTermCode: planPackage.carrierTermCode,
      optionPremium: planPackage.optionPremium,
      productOptionLongDescription: planPackage.productOptionLongDescription,
    };
    return packageObj;
  }

  isLDAppSource() {
    if (this.data.insuranceInfo.quoteRequestSource === 'LeasingDesk Call Center') {
      return true;
    } else {
      return false;
    }
  }

  isERP() {
    if (this.data.insuranceInfo.quoteRequestSource === 'eRenterPlan Integration') {
      return true;
    } else {
      return false;
    }
  }

  /** Local & Session Storage Services */

  saveStorageValue(storageType, key, value) {
    if (storageType == 'localStorage') {
      // save local storage item
      this.localStorage.store(key, value);
    } else {
      // save session storage item
      this.sessionStorage.store(key, value);
    }
  }

  retrieveStorageValue(storageType, key) {
    if (storageType == 'localStorage') {
      // retrieve local storage item
      return this.localStorage.retrieve(key);
    } else {
      // retrieve session storage item
      return this.sessionStorage.retrieve(key);
    }
  }

  clearStorageItem(storageType, key) {
    if (storageType == 'localStorage') {
      // clear specific local storage item
      this.localStorage.clear(key);
    } else {
      // clear specific session storage item
      this.sessionStorage.clear(key);
    }
  }

  clearStorage(storageType) {
    if (storageType == 'localStorage') {
      // clear all the local storage items
      this.localStorage.clear();
    } else {
      // clear all the session storage items
      this.sessionStorage.clear();
    }
  }
}
